import { Injectable } from "@angular/core";

import {ClienteDTO, PaginadoDTO, PanelDTO} from "@DTOS";
import { PanelsServiceBackend } from "@serviceBackends";
import {Observable} from "rxjs";
import {DatosModalPanel} from "../../layout/saas/crear-desde-archivo-modal/DatosModalPanel";

@Injectable({
    providedIn: "root"
})
export class PanelsService {

    constructor(private panelsServiceBackend: PanelsServiceBackend) { }

    public obtenerPanels(cantidad = 10, pagina = 1): Observable<PaginadoDTO<PanelDTO>> {
        return this.panelsServiceBackend.getPanels(cantidad, pagina);
    }

    public obtenerPanel(id: number): Promise<PanelDTO> {
        return this.panelsServiceBackend.getPanel(id);
    }

    public agregarPanel(panel: PanelDTO): Promise<PanelDTO> {
        return this.panelsServiceBackend.postPanels(panel);
    }

    public actualizarPanel(panel: PanelDTO): Promise<PanelDTO> {
        return this.panelsServiceBackend.putPanel(panel);
    }

    public borrarPanel(panel: PanelDTO): Promise<boolean> {
        return this.panelsServiceBackend.deletePanel(panel);
    }
    public subirArchivo(panel: PanelDTO, archivo: Blob, dashboard): Promise<void> {
        return this.panelsServiceBackend.postSubirArchivo(panel.id, archivo, dashboard);
    }
    public crearDesdeArchivo(datos: DatosModalPanel, clientes: ClienteDTO[], archivo: Blob ): Promise<void> {
        return this.panelsServiceBackend.postCrearDesdeArchivo(datos, clientes, archivo);
    }
}
